import {
  Children,
  type FC,
  isValidElement,
  type ReactElement,
  type ReactNode,
} from "react";

interface ButtonCountdownProps {
  isLoading: boolean;
  isRetryActive: boolean;
  children: ReactNode;
}

interface ButtonCountdownContentProps {
  children: ReactNode;
}

export interface ButtonCountdownCompound extends FC<ButtonCountdownProps> {
  Loading: FC<ButtonCountdownContentProps>;
  Retry: FC<ButtonCountdownContentProps>;
  Default: FC<ButtonCountdownContentProps>;
}

export const ButtonCountdown: ButtonCountdownCompound = ({
  isLoading,
  isRetryActive,
  children,
}) => {
  const childArray = Children.toArray(children) as ReactElement[];

  const getChild = (slot: FC<ButtonCountdownContentProps>) =>
    childArray.find((child) => isValidElement(child) && child.type === slot) ??
    null;

  if (isLoading) {
    const loadingChild = getChild(ButtonCountdown.Loading);
    if (loadingChild) return loadingChild;
  }

  if (isRetryActive) {
    const retryChild = getChild(ButtonCountdown.Retry);
    if (retryChild) return retryChild;
  }

  // Fallback to Default (or null if not provided)
  return getChild(ButtonCountdown.Default);
};

ButtonCountdown.Loading = function Loading({
  children,
}: ButtonCountdownContentProps) {
  return <>{children}</>;
};

ButtonCountdown.Retry = function Retry({
  children,
}: ButtonCountdownContentProps) {
  return <>{children}</>;
};

ButtonCountdown.Default = function Default({
  children,
}: ButtonCountdownContentProps) {
  return <>{children}</>;
};
